import type { MachineKind } from '../core/entities';
import { SUBJECT_COST } from './economy';
import type { CreationKind } from './creation-kinds';

/**
 * Everything the build toolbar can hand the player. `'subject'` stands outside both other groups
 * because it is neither: it creates no packets, so it is no creation operator, and it sits in no
 * pipe, so it is no machine.
 */
export type BuildKind = CreationKind | MachineKind | 'subject';

/**
 * No parens on the label, unlike every operator: a Subject is a class you construct, not a function
 * you call, and the codegen it produces reads `new Subject<void>()`.
 */
export const SUBJECT_DEF = {
  label: 'Subject',
  cost: SUBJECT_COST,
  description: 'a named signal other tiles can watch',
  expandedDescription:
    'Both an Observable and an Observer. Here it carries a signal rather than a packet — pure information, which is the one thing this world lets you copy, since a material cannot be in two places at once. It has no ports and touches no belt: publishers and listeners find it by its name, the way `destroy$` is found across a codebase. Place it anywhere, then point something at it.',
  docsUrl: 'https://rxjs.dev/guide/subject',
} as const;
